import { PATHS, useSessionStore } from '@ctcells/core'
import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'

import { ScreenLoading } from '../screens/ScreenState.tsx'

/**
 * 인증 가드. 판정의 주체는 서버다 — 여기서는 노출만 가른다.
 *
 * 🔴 **`unknown` 은 통과가 아니라 로딩이다.** 부팅 시 저장된 refresh 토큰으로 조용히 갱신하는
 *    동안이 이 상태인데, 통과시키면 **권한을 모르는 채로 화면이 뜬다** — 조작 버튼이 한 프레임
 *    잘못 그려질 수 있다. 막고 기다린다.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const status = useSessionStore((state) => state.status)
  const location = useLocation()

  if (status === 'anonymous') {
    return <Navigate to={PATHS.login} replace state={{ from: location.pathname }} />
  }

  if (status === 'unknown') {
    /*
     * 🔴 **맨 글자였다**(2026-09-22). 부팅 때 저장된 refresh 로 조용히 갱신하는 «그 잠깐»이
     *    화면 왼쪽 위의 회색 글자 한 줄이라, 느린 회선에서는 앱이 깨진 것처럼 보였다.
     *    다른 경계 상태와 같은 덩이로 세운다 — 셸은 `shell--plain` 그대로다(헤더를 아직
     *    그릴 수 없다. 역할을 모르니 메뉴도 모른다).
     */
    return (
      <div className="shell shell--plain" aria-live="polite">
        <div className="shell__body">
          <ScreenLoading />
        </div>
      </div>
    )
  }

  return children
}
